import { User2 } from "lucide-react";
import { cn } from "@/lib/cn";
import { FallbackImage } from "@/components/ui/fallback-image";

export function Avatar({ src, alt, className }: { src?: string | null; alt?: string; className?: string }) {
  if (src) {
    return <FallbackImage alt={alt ?? "Avatar"} className={cn("h-10 w-10 rounded-2xl border border-white/10", className)} label="No image" objectClassName="object-cover" src={src} />;
  }

  return (
    <div className={cn("flex h-10 w-10 items-center justify-center rounded-2xl border border-white/10 bg-white/5", className)}>
      <User2 className="h-5 w-5 text-slate-300" />
    </div>
  );
}
